(() => {
  const filtersAside = () => document.getElementById('main-collection-filters');

  const headerSel = '.header-wrapper, header.header, .section-header';
  const annSel = '.announcement-bar, .announcement-bar-section';

  const setStickyTop = () => {
    const header = document.querySelector(headerSel);
    const ann = document.querySelector(annSel);

    const headerH = header ? header.offsetHeight : 0;
    const annH = ann ? ann.offsetHeight : 0;

    // announcement bazen header dışında olabiliyor
    const top = Math.max(headerH, 0) + Math.max(annH, 0);
    document.documentElement.style.setProperty('--sticky-top', `${top}px`);
  };

  const setFacetsBoxVars = () => {
    const aside = filtersAside();
    if (!aside) return;

    // aside’ın sayfadaki gerçek konumu ve genişliği
    const r = aside.getBoundingClientRect();
    const left = Math.round(r.left);
    const width = Math.round(r.width);

    // fixed konum/ölçü için CSS variable
    document.documentElement.style.setProperty('--facets-left', `${left}px`);
    document.documentElement.style.setProperty('--facets-width', `${width}px`);
  };

  const updateAll = () => {
    setStickyTop();
    setFacetsBoxVars();
  };

  // İlk yükleme + resize
  window.addEventListener('load', updateAll);
  window.addEventListener('resize', updateAll);

  // Scroll: header state + ölçüler değişebilir (özellikle sticky header devreye girince)
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateAll();
      ticking = false;
    });
  }, { passive: true });

  // ✅ Kritik: body class değişince (.scrolled-past-header) tekrar ölç
  const mo = new MutationObserver(updateAll);
  mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // Shopify section reload (tema editörde)
  document.addEventListener('shopify:section:load', updateAll);
})();
